import { render } from "./EditIbutton.vue?vue&type=template&id=cb44aae8"
import script from "./EditIbutton.vue?vue&type=script&lang=js"
export * from "./EditIbutton.vue?vue&type=script&lang=js"
script.render = render

export default script